export default "__VITE_ASSET__CtpoAR9k__"